import React, { ReactElement, useEffect, useState } from 'react';

import { createUrl, request } from 'app/utils';

import { Flex, Box, Typography, Button, Section, Row, Col } from 'components';
import { ProductsCard, ProgramsApiResponse, useProducts } from 'features/products';
import { Link } from 'react-router-dom';

import { useSchool } from 'features/school';

interface ProgramsListProps {
  type: 'highlighted' | 'my';
}

const ProgramsList = ({ type }: ProgramsListProps): ReactElement => {
  const [, setLoading] = useState(true);
  const [fetched, setFetched] = useState(false);
  const { apiGatewayUrl } = useSchool();

  const { programs, setPrograms, clearPrograms, programsMy, setProgramsMy, clearProgramsMy } = useProducts();

  const isMyPrograms = type === 'my';

  const fetchPrograms = async () => {
    setLoading(true);

    await request<ProgramsApiResponse>({
      url: isMyPrograms ? '/api/v1/School/MyPrograms' : '/api/v1/School/HighlightedPrograms',
      method: 'get',
      baseURL: apiGatewayUrl,
    })
      .then(({ data }) => {
        if (isMyPrograms) {
          setProgramsMy(data);
        } else {
          setPrograms(data);
        }
      })
      .finally(() => {
        setFetched(true);
        setLoading(false);
      });
  };

  let hat = '';
  let title = 'Programas';
  let buttonLabel = '';

  if (isMyPrograms) {
    title = 'Meus programas';
  }

  useEffect(() => {
    fetchPrograms();

    return () => {
      clearPrograms();
      clearProgramsMy();
    };
  }, []);

  return fetched && ((isMyPrograms && programsMy?.length) || (!isMyPrograms && programs?.length)) ? (
    <Flex bg="dark_350" borderTop="1px solid" borderColor="dark_150" py={{ m: 30, t: 60, d: 90 }}>
      <Section flexDirection="column">
        <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end">
          <Flex flexDirection="column">
            {!!hat && (
              <Typography type="type3" color="white" upper mb={1}>
                {hat}
              </Typography>
            )}

            <Typography as="h2" type="type8" color="white" fontWeight="bold">
              {title}
            </Typography>
          </Flex>

          {!!buttonLabel && (
            <Box width="auto" flexGrow={0} justifyContent="flex-end">
              <Link to={createUrl('productsList')}>
                <Button mt={{ m: 20 }}>{buttonLabel}</Button>
              </Link>
            </Box>
          )}
        </Flex>

        <Row gutter={20} mt={2}>
          {(isMyPrograms ? programsMy : programs).map((program, index) => (
            <Col key={`program-card-${program.uuid}-${index.toString()}}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mt={4}>
              <ProductsCard active={isMyPrograms} product={program} theme="dark" />
            </Col>
          ))}
        </Row>
      </Section>
    </Flex>
  ) : (
    <></>
  );
};

export default ProgramsList;
